/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Button,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import Table from 'components/Table';
import Select from 'components/Select';
import {
  getAreas,
} from 'api/catalogos/index';
import { getIncidenciasEmpleadosDetalles } from 'api/nominas/incidencias/incidenciasEmpleadosDetalles';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getIncidenciasEmpleados } from 'api/nominas/incidencias/incidenciasEmpleados';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getEmpleadosConDatosOpFilteredPaginated, getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPuestos } from 'api/catalogos/puestos';
import { checkToken } from 'api/utils';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { SearchOutlined } from '@ant-design/icons';
import CustomSearch from 'components/customSearch';

export const incidenciaPersonalizadaPermission = {
  permissionModel: 'incidenciaempleadodetalle',
  catalogsModels: [],
  tabsModels: [],
};

const IncidenciaPersonalizada = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [areas, setAreas] = useState();
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState();
  const [plaza, setPlaza] = useState();
  const [area, setArea] = useState();
  const [puestos, setPuestos] = useState();
  const [puesto, setPuesto] = useState();
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [incidencias, setIncidencias] = useState([]);
  const [empleado, setEmpleado] = useState();
  const [incidencia, setIncidencia] = useState();
  const [incidenciasEmpleados, setIncidenciasEmpleados] = useState([]);
  const [tiposIncidenciasUnidades, setTiposIncidenciasUnidades] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [tiposDeEmpleados, setTiposDeEmpleados] = useState([]);
  const [tipoDeEmpleado, setTipoDeEmpleado] = useState();
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [openSearch, setVisibleSearch] = useState(false);
  const [dataSearch, setDataSearch] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();

  let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const fetchData = async () => {
    setLoading(true);

    if (incidencia) {
      const _data = await getIncidenciasEmpleadosDetalles({
        empleado,
        incidencia_empleado: incidencia,
      });
      setData(formatReceived(_data));
    } else {
      setData([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _areas,
        _empleados,
        _plazas,
        _puestos,
        _adminPlazas,
        _incidencias,
        _incidenciasEmpleados,
        _tiposIncidenciasUnidades,
        _periodosNominasDetalles,
        _periodosNominas,
        _tiposEmpleados,
        _tipos_de_nominas_empleados,
      ] = await Promise.all([
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getEmpleadosOptimized(),
        getPlazasvistaOptimized(),
        getPuestos(),
        getAdministracionDePlazasvistaOptimized(),
        getConfiguracionIncidencias({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasEmpleados(),
        getTiposDeIncidenciasUnidades(),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas(),
        getTiposDeEmpleados(),
        getTiposDeNominasEmpleados(),
      ]);
      const formattedURS = normalizeData(_areas);
      if (mounted) {
        setAreas(formattedURS);
        setEmpleados(_empleados);
        setPlazas(_plazas);
        setPuestos(_puestos);
        setAdminPlazas(_adminPlazas);
        setIncidencias(_incidencias);
        setIncidenciasEmpleados(_incidenciasEmpleados);
        setTiposIncidenciasUnidades(_tiposIncidenciasUnidades);
        setPeriodosNominasDetalles(_periodosNominasDetalles.filter((periodosNomDetalle) => _periodosNominas.some((periodoNomina) => periodoNomina.id === periodosNomDetalle?.periodo_de_nomina)));
        setTiposDeEmpleados(_tiposEmpleados);
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (empleado) {
      fetchData();
    }
  }, [incidencia]);

  const onChangeEmpleado = (value) => {
    const _empleado = empleados.find((e) => e.id === value);
    const _admin = adminPlazas.find((e) => e.empleado === _empleado?.id);
    const _plaza = plazas.find((e) => e.id === _admin?.plaza);
    const _puesto = puestos.find((e) => e.id === _plaza?.puesto);
    const _area = areaBuscar(_plaza?.area_content_id, areas);
    const _tipoEmpleado = tiposDeEmpleados.find((e) => e.id === _puesto?.tipo_empleado)?.descripcion;
    setPuesto(_puesto?.descripcion);
    setArea(_area?.title);
    setPlaza(_plaza?.clave);
    setEmpleado(value);
    setTipoDeEmpleado(_tipoEmpleado);
    form.resetFields(['incidencia', 'descuento']);
    setData([]);
  };

  const validateInput = async () => {
    setLoading(true);
    setSelectedEmpleadoSearch();
    const searchEmp = form.getFieldValue('empleado');
    if (!searchEmp) {
      setVisibleSearch(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`);
    const result = res?.results[0];
    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    setSelectedEmpleadoSearch(empleadoResult);
    if (empleadoResult) {
      form.setFieldsValue({
        empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
      });
    } else {
      form.resetFields(['empleado']);
    }
    onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURIDatosOpPaginado);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
    setDataSearch(_empleados);
    return setLoading(false);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (empObject) => {
        const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
        const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
        const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
        return `${puestoEmp?.descripcion || ''}`;
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  const columns = [
    {
      titleText: 'Incidencia',
      dataIndex: 'incidencia_empleado',
      key: 'incidencia_empleado',
      width: 200,
      render: (val) => {
        const _incidencia = incidenciasEmpleados.find((e) => e.id === val);
        return incidencias.find((e) => e.id === _incidencia?.incidencia)?.concepto;
      },
    },
    {
      titleText: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
      width: 200,
      render: (val) => (val || 0),
    },
    {
      titleText: 'Unidad de Incidencia',
      dataIndex: 'tipo_de_incidencia_unidad',
      key: 'tipo_de_incidencia_unidad',
      width: 200,
      render: (val) => tiposIncidenciasUnidades.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Nómina de Aplicación',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 300,
      render: (val) => {
        const _periodo = periodosNominasDetalles.find((e) => e.id === val);
        return _periodo ? `${_periodo.numero_de_nomina} (${_periodo.fecha_inicial} al ${_periodo.fecha_final})` : '';
      },
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
        >
          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Form.Item
                        label="No. y Nombre del Empleado"
                        name="empleado"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                      <Button
                        loading={loading}
                        onClick={validateInput}
                        icon={<SearchOutlined />}
                        style={{
                          width: '2.7rem',
                          marginTop: '-2px',
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              {selectedEmpleadoSearch
                ? (
                  form.setFieldsValue({
                    empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
                  })
                ) : null}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Puesto"
                >
                  <Input
                    allowClear
                    disabled
                    value={puesto}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Área"
                >
                  <Input
                    allowClear
                    disabled
                    value={area}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Tipo de Empleado"
                >
                  <Input
                    disabled
                    value={tipoDeEmpleado}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="No. de Plaza"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled
                    value={plaza}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="descuento"
                  label="Concepto de Incidencia"
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="concepto"
                    dataSource={incidencias}
                    onChange={(value) => {
                      const _incidenciaEmpleado = incidenciasEmpleados.find((e) => e.incidencia === value && e.empleado === empleado);
                      setIncidencia(_incidenciaEmpleado?.id);
                    }}
                    disabled={!empleado}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Table
            cols={columns}
            data={data}
            allowExportPDF={false}
          />
        </Card>
        <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={onChangeEmpleado}
        />
      </Spin>
    </Row>
  );
};

export default IncidenciaPersonalizada;
